import {
  DsDatepickerModule,
  DsFormsModule,
  DsImprintModule,
} from '@bmw-ds/components';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { OAuthModule } from 'angular-oauth2-oidc';

import { routes } from './app.routes';
import { authenticationInterceptor } from './services/authentication-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authenticationInterceptor])),
    importProvidersFrom(
      DsFormsModule.forRoot({
        markRequiredFormLabels: true,
      }),
      DsImprintModule.forRoot({
        phone: 'xxx',
        electronicContact: 'xxx@bmwgroup.com',
        region: 'US',
      }),
      DsDatepickerModule.forRoot({
        showClearAll: false,
      }),
      BrowserAnimationsModule,
      OAuthModule.forRoot()
    ),
    provideRouter(routes),
  ],
};
